var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',[_c('p',{staticClass:"text-center"},[_vm._v("Thank you for choosing Carman & Associates and we look forward to assisting you with the application.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }